const popularSearchesButton = document.querySelector('.popular__searches__tag__button');

if (popularSearchesButton) {
    popularSearchesButton.addEventListener('click', () => {
        document.querySelector('.popular__searches__tag').classList.toggle('active');
    });
}